import React, { useEffect, useState } from 'react';
import styles from './WarehouseModal.module.css';
import { API_URL } from '../../../config/api';


const WarehouseModal = ({ isOpen, onClose, onSelect }) => {
  const token = localStorage.getItem('token'); // ✅ токен
  const [warehouses, setWarehouses] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (isOpen) {
      const fetchWarehouses = async () => {
        try {
          const res = await fetch(`${API_URL}/api/storages?status=active`, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });

          const data = await res.json();
          console.log('GET warehouses response:', data);

          if (Array.isArray(data.data)) {
            setWarehouses(data.data);
            localStorage.setItem('warehouses', JSON.stringify(data.data)); // кэшируем
          } else {
            console.warn('⚠️ Ожидался массив складов, но пришло:', data);
            const saved = localStorage.getItem('warehouses');
            if (saved) setWarehouses(JSON.parse(saved));
            else setWarehouses([]);
          }
        } catch (err) {
          console.error('Ошибка при загрузке складов:', err);
          const saved = localStorage.getItem('warehouses');
          if (saved) setWarehouses(JSON.parse(saved));
          else setWarehouses([]);
        }
      };

      if (token) fetchWarehouses();
      else console.error('❌ Нет токена! Авторизация не выполнена.');
    }
  }, [isOpen, token]);

  const handleConfirm = () => {
    const selectedWarehouse = warehouses.find(w => w.id === selectedId);
    console.log('Выбранный склад:', selectedWarehouse);
    if (selectedWarehouse) onSelect(selectedWarehouse);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <h2>Список складов</h2>
        <div className={styles.scrollArea}>
          <ul className={styles.list}>
            {(warehouses || []).map((warehouse) => ( 
              <li key={warehouse.id} className={styles.item}>
                <label className={styles.radioLabel}>
                  <input
                    type="radio"
                    name="warehouse"
                    value={warehouse.id}
                    checked={selectedId === warehouse.id}
                    onChange={() => setSelectedId(warehouse.id)}
                  />
                  <span className={styles.customRadio}></span>
                  {warehouse.name}
                </label>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.modalButtons}>
          <button className={styles.add} onClick={handleConfirm}>Выбрать</button>
          <button className={styles.cancel} onClick={onClose}>Отмена</button>
        </div>
      </div>
    </div>
  );
};

export default WarehouseModal;
